export const EMPLEADOS_REQUEST = "EMPLEADOS_REQUEST";
export const EMPLEADOS_REFRESH = "EMPLEADOS_REFRESH";
export const EMPLEADOS_OK = "EMPLEADOS_OK";
export const EMPLEADOS_ERROR = "EMPLEADOS_ERROR";
